





























import { Component, Vue } from 'vue-property-decorator'
import { STORAGE_KEY_DISCOVERY_SPOTIFY_HISTORY } from '@/store/modules/discovery'
import { SPOTIFY_PLAYLIST_REGEX } from '@/constants'

@Component({
  components: {
    Controls: require('../Controls').default,
    ProgressLoader: require('@/components/ProgressLoader').default
  }
})
export default class Spotify extends Vue {
  // playlistLink: string = 'https://open.spotify.com/playlist/2lezdnYuZ0xQ5ZxfTJImid?si=pTCQVbUEQaOEF_Mf2v3dNw'
  // playlistLink: string = 'https://open.spotify.com/playlist/5gDXV2U8h03jy4Pa6C1FS0?si=ayzc3r_mSoSKvkpA-UZauQ'
  // playlistLink: string = 'https://open.spotify.com/playlist/7s9qNlssOJ912reWr1Tt1j?si=sgu_KK4zQ221-fET4vdd0w'
  playlistLink: string = ''
  loading: boolean = false

  history: any[] | null = null

  get disabled(): boolean {
    return !this.playlistLink.includes('spotify:playlist:') && !SPOTIFY_PLAYLIST_REGEX.test(this.playlistLink)
  }

  start() {
    this.$store.commit('discovery/setSpotifyPlaylistLink', this.playlistLink)
  }

  useHistory(h) {
    this.playlistLink = h.playlistLink
  }

  created() {
    const historyStr = localStorage.getItem(STORAGE_KEY_DISCOVERY_SPOTIFY_HISTORY)

    if (historyStr) {
      this.history = JSON.parse(historyStr)
    }

    if (this.$route.query.playlistLink) {
      this.playlistLink = this.$route.query.playlistLink as string
    }
  }
}
